export function toLowerCaseAscii(str: string): string {
    const [A, Z, a] = ['A', 'Z', 'a'].map(char => char.charCodeAt(0));

    const toLowerCaseCharCode = (charCode: number) => {
        if (charCode >= A && charCode <= Z) {
            return charCode + (a - A);
        } else {
            return charCode;
        }
    };

    const charCodes = Array.from(str).map(char => char.charCodeAt(0));
    const lowerCaseCharCodes = charCodes.map(toLowerCaseCharCode);
    const chars = lowerCaseCharCodes.map(charCode => String.fromCharCode(charCode));
    return ''.concat(...chars);
}
